export default __webpack_public_path__ + "static/media/master.1f26b588.png";